import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatPrice } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product, index = 0 }) {
  const { addItem, has } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
      className="group bg-cream border border-line rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300 flex flex-col"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/ebook/${product.slug}`} className="block bg-white p-4 border-b border-line">
        <img src={product.cover_url} alt={product.title} loading="lazy"
          className="w-full h-72 object-contain book-shadow rounded-sm group-hover:scale-[1.02] transition-transform duration-300" />
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <p className="font-overline text-terracotta mb-1">{product.category}</p>
        <h3 className="font-heading text-xl text-ink leading-tight">{product.title}</h3>
        <p className="text-sm text-ink-muted mt-2 leading-relaxed flex-1">{product.short_description}</p>
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-baseline gap-2">
            <span className="text-lg font-semibold text-ink">{formatPrice(product.price)}</span>
            {product.compare_price && <span className="text-sm text-ink-muted line-through">{formatPrice(product.compare_price)}</span>}
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <Button asChild variant="outline" className="flex-1 border-line text-ink hover:bg-sand rounded-md" data-testid={`discover-${product.slug}`}>
            <Link to={`/ebook/${product.slug}`}>Découvrir</Link>
          </Button>
          <Button onClick={() => addItem(product)} disabled={has(product.id)} className="flex-1 bg-terracotta hover:bg-terracotta-dark text-white rounded-md" data-testid={`add-${product.slug}`}>
            {has(product.id) ? "Ajouté" : "Acheter"}
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
